import ControlledDropdown from '../ControlledDropdown';
import { DropdownOption } from '../DropDown';
import { useEffect, useState } from 'react';
import AuthorisedHospitalList from '@src/cache/AuthorisedHospitalList';

interface Props {
  fieldName: string;
}

function ControlledHospitalAutoComplete({ fieldName }: Props) {
  const [available, setAvailable] = useState<DropdownOption[]>([]);
  const { getList } = AuthorisedHospitalList();

  useEffect(() => {
    getList().then((result) => {
      console.log(result);
      const items = result
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => ({
          id: item.id || '',
          name: item.name,
        }));
      setAvailable(items);
    });
  }, [getList]);

  return (
    <ControlledDropdown
      fieldName={fieldName}
      label="Hospital"
      options={available}
      disableClearable={true}
    />
  );
}
export default ControlledHospitalAutoComplete;
